export enum CompleteChartConstants {
  SET_SELECTED_OPTION = 'CompleteChart/SET_SELECTED_OPTION',
  SET_ERRORS_TAB = 'CompleteChart/SET_ERRORS_TAB',
  SET_WARNINGS_TAB = 'CompleteChart/SET_WARNINGS_TAB',
  SET_LOCK_CHART = 'CompleteChart/SET_LOCK_CHART',
  CALCULATE_BILLING_CMS = 'CompleteChart/CALCULATE_BILLING_CMS',
  SET_CMS_VALUE = 'CompleteChart/SET_CMS_VALUE',
  OFFLINE_ERRORS_FIXED = 'CompleteChart/OFFLINE_ERRORS_FIXED',
  LOCKED_READY_TO_UPLOAD = 'CompleteChart/LOCKED_READY_TO_UPLOAD',
  SET_USER = 'signer/SET_USER',
  SET_SIGN_CHART_AS = 'signer/SET_SIGN_CHART_AS',
  SET_PIN = 'signer/SET_PIN',
  SET_ANSWER1 = 'signer/SET_ANSWER1',
  SET_ANSWER2 = 'signer/SET_ANSWER2',
  SET_VERIFY_CREW = 'signer/SET_VERIFY_CREW',
  SET_CLINICAL_USER = 'signer/SET_CLINICAL_USER',
  SET_QUESTION_LIST = 'signer/SET_QUESTION_LIST',
  SET_CLINICAL_USER_LIST = 'signer/SET_CLINICAL_USER_LIST',
  SET_SECURITY_QUESTION_ANSWER_LIST = 'signer/SET_SECURITY_QUESTION_ANSWER_LIST',
  SET_SERVICES_BILLING = 'signer/SET_SERVICES_BILLING',
  SET_COMPLEX_RULES_COUNT = 'signer/SET_COMPLEX_RULES_COUNT',
  ADD_SIGNER = 'signer/ADD_SIGNER',
  SET_SIGNER_LIST = 'signer/SET_SIGNER_LIST',
  DELETE_SIGNER = 'signer/DELETE_SIGNER',
  SET_CURRENT_SIGNER = 'signer/SET_CURRENT_SIGNER',
  SAVE_SIGNER = 'signer/SAVE_SIGNER',
  RESET_SIGNER = 'signer/RESET_SIGNER',
  CLEAR_ALL_SIGNER_DATA = 'signer/CLEAR_ALL_SIGNER_DATA',
  SET_EXTRA_SECURITY_ID = 'signer/SET_EXTRA_SECURITY_ID',
}
